import { postApi } from "../services/axios";
import APIs from ".";
import store from "../redux";
import { setUserInfo } from "../redux/modules/auth/actions";
import { resetStore } from "../redux/modules";

function setTokenData(data) {
  localStorage.setItem("token", `Bearer ${data.token}`);
  localStorage.setItem("user", JSON.stringify({ ...data }));
}

export async function userLogin(payload) {
  const res = await postApi(APIs.AUTH.LOGIN, payload, {
    validateUser: false,
  });

  if (res.success) {
    setTokenData(res.data);
  }

  return res;
}

export async function validateToken() {
  if (localStorage.user) {
    const data = JSON.parse(localStorage.user);

    store.dispatch(
      setUserInfo({
        user: { ...data, isLoggedIn: true },
      })
    );

    return {
      success: true,
    };
  }

  return {
    success: false,
  };
}

export async function userLogout() {
  localStorage.clear();

  store.dispatch(resetStore());
}
